import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TeamsPhoneNumberAssignment } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MicrosoftAlternateLinesResource {
  private http = inject(HttpClient);

  getTeamsPhoneNumberAssignments(
    tenantId: string,
    userPrincipalName: string,
  ): Observable<TeamsPhoneNumberAssignment[]> {
    return this.http.get<TeamsPhoneNumberAssignment[]>(this._buildUrl(tenantId, userPrincipalName));
  }

  deleteTeamsPhoneNumberAssignment(
    tenantId: string,
    userPrincipalName: string,
    lineUri: string,
    lineUriExtension: string,
  ): Observable<void> {
    const alternateLineUrl = `${this._buildUrl(tenantId, userPrincipalName)}/${encodeURIComponent(lineUri)}`;
    const url = lineUriExtension
      ? `${alternateLineUrl}/extensions/${encodeURIComponent(lineUriExtension)}`
      : alternateLineUrl;
    return this.http.delete<void>(url);
  }

  private _buildUrl(tenantId: string, userPrincipalName: string): string {
    return `/services/microsoft/teams-user-management/tenants/${tenantId}/teams-phone-number-assignment/${encodeURIComponent(userPrincipalName)}/alternate-lines`;
  }
}
